/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BaseHit Api
 * An API for accessing data for BaseHit.com
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetNotificationsParams,
  NotificationPreferenceUpdate,
  NotificationPreferencesResponse,
  NotificationUnreadCountResponse,
  NotificationsPageResponse,
  ProblemDetails
} from '../models';

import { fetcher } from '../../fetcher';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Unread notification count — the header bell badge poll.
 */
export const getNotificationsUnreadCount = (

 signal?: AbortSignal
) => {


      return fetcher<NotificationUnreadCountResponse>(
      {url: `/Notifications/UnreadCount`, method: 'GET', signal
    },
      );
    }




export const getGetNotificationsUnreadCountQueryKey = () => {
    return [
    `/Notifications/UnreadCount`
    ] as const;
    }


export const getGetNotificationsUnreadCountQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationsUnreadCount>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationsUnreadCount>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationsUnreadCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationsUnreadCount>>> = ({ signal }) => getNotificationsUnreadCount(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationsUnreadCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationsUnreadCountQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationsUnreadCount>>>
export type GetNotificationsUnreadCountQueryError = ProblemDetails


export function useGetNotificationsUnreadCount<TData = Awaited<ReturnType<typeof getNotificationsUnreadCount>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationsUnreadCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsUnreadCount>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsUnreadCount<TData = Awaited<ReturnType<typeof getNotificationsUnreadCount>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationsUnreadCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsUnreadCount>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsUnreadCount<TData = Awaited<ReturnType<typeof getNotificationsUnreadCount>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationsUnreadCount>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Unread notification count — the header bell badge poll.
 */

export function useGetNotificationsUnreadCount<TData = Awaited<ReturnType<typeof getNotificationsUnreadCount>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationsUnreadCount>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNotificationsUnreadCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary A page of the caller's notifications (cursor ?before={id} loads older).
 */
export const getNotifications = (
    params?: GetNotificationsParams,
 signal?: AbortSignal
) => {


      return fetcher<NotificationsPageResponse>(
      {url: `/Notifications`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetNotificationsQueryKey = (params?: GetNotificationsParams,) => {
    return [
    `/Notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof getNotifications>>, TError = ProblemDetails>(params?: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotifications>>> = ({ signal }) => getNotifications(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotifications>>>
export type GetNotificationsQueryError = ProblemDetails


export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = ProblemDetails>(
 params: undefined |  GetNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = ProblemDetails>(
 params?: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = ProblemDetails>(
 params?: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A page of the caller's notifications (cursor ?before={id} loads older).
 */

export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = ProblemDetails>(
 params?: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Mark one notification read.
 */
export const putNotificationsIdRead = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Notifications/${id}/Read`, method: 'PUT', signal
    },
      );
    }




export const getPutNotificationsIdReadMutationKey = () => ['putNotificationsIdRead'] as const;

export const getPutNotificationsIdReadMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNotificationsIdRead>>, TError,PutNotificationsIdReadMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putNotificationsIdRead>>, TError,PutNotificationsIdReadMutationVariables, TContext> => {

const mutationKey = getPutNotificationsIdReadMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putNotificationsIdRead>>, PutNotificationsIdReadMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  putNotificationsIdRead(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutNotificationsIdReadMutationResult = NonNullable<Awaited<ReturnType<typeof putNotificationsIdRead>>>

    export type PutNotificationsIdReadMutationError = ProblemDetails
    export type PutNotificationsIdReadMutationVariables = {id: number}

    /**
 * @summary Mark one notification read.
 */
export const usePutNotificationsIdRead = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNotificationsIdRead>>, TError,PutNotificationsIdReadMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putNotificationsIdRead>>,
        TError,
        PutNotificationsIdReadMutationVariables,
        TContext
      > => {
      return useMutation(getPutNotificationsIdReadMutationOptions(options), queryClient);
    }
    /**
 * @summary Mark all the caller's notifications read.
 */
export const putNotificationsReadAll = (

 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Notifications/ReadAll`, method: 'PUT', signal
    },
      );
    }




export const getPutNotificationsReadAllMutationKey = () => ['putNotificationsReadAll'] as const;

export const getPutNotificationsReadAllMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNotificationsReadAll>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putNotificationsReadAll>>, TError,void, TContext> => {

const mutationKey = getPutNotificationsReadAllMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putNotificationsReadAll>>, void> = () => {


          return  putNotificationsReadAll()
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutNotificationsReadAllMutationResult = NonNullable<Awaited<ReturnType<typeof putNotificationsReadAll>>>

    export type PutNotificationsReadAllMutationError = ProblemDetails


    /**
 * @summary Mark all the caller's notifications read.
 */
export const usePutNotificationsReadAll = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNotificationsReadAll>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putNotificationsReadAll>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPutNotificationsReadAllMutationOptions(options), queryClient);
    }
    /**
 * @summary The full notification-preference matrix (every type, effective in-app/email).
 */
export const getNotificationsPreferences = (

 signal?: AbortSignal
) => {


      return fetcher<NotificationPreferencesResponse>(
      {url: `/Notifications/Preferences`, method: 'GET', signal
    },
      );
    }




export const getGetNotificationsPreferencesQueryKey = () => {
    return [
    `/Notifications/Preferences`
    ] as const;
    }


export const getGetNotificationsPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationsPreferences>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationsPreferences>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationsPreferencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationsPreferences>>> = ({ signal }) => getNotificationsPreferences(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationsPreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationsPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationsPreferences>>>
export type GetNotificationsPreferencesQueryError = ProblemDetails


export function useGetNotificationsPreferences<TData = Awaited<ReturnType<typeof getNotificationsPreferences>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationsPreferences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsPreferences>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsPreferences>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsPreferences<TData = Awaited<ReturnType<typeof getNotificationsPreferences>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationsPreferences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsPreferences>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsPreferences>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsPreferences<TData = Awaited<ReturnType<typeof getNotificationsPreferences>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationsPreferences>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The full notification-preference matrix (every type, effective in-app/email).
 */

export function useGetNotificationsPreferences<TData = Awaited<ReturnType<typeof getNotificationsPreferences>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationsPreferences>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNotificationsPreferencesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update notification preferences (a list of per-type in-app/email settings).
 */
export const putNotificationsPreferences = (
    notificationPreferenceUpdate?: NotificationPreferenceUpdate[],
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/Notifications/Preferences`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: notificationPreferenceUpdate, signal
    },
      );
    }




export const getPutNotificationsPreferencesMutationKey = () => ['putNotificationsPreferences'] as const;

export const getPutNotificationsPreferencesMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNotificationsPreferences>>, TError,PutNotificationsPreferencesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putNotificationsPreferences>>, TError,PutNotificationsPreferencesMutationVariables, TContext> => {

const mutationKey = getPutNotificationsPreferencesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putNotificationsPreferences>>, PutNotificationsPreferencesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putNotificationsPreferences(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutNotificationsPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof putNotificationsPreferences>>>
    export type PutNotificationsPreferencesMutationBody = NotificationPreferenceUpdate[] | undefined
    export type PutNotificationsPreferencesMutationError = ProblemDetails
    export type PutNotificationsPreferencesMutationVariables = {data?: NotificationPreferenceUpdate[]}

    /**
 * @summary Update notification preferences (a list of per-type in-app/email settings).
 */
export const usePutNotificationsPreferences = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNotificationsPreferences>>, TError,PutNotificationsPreferencesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putNotificationsPreferences>>,
        TError,
        PutNotificationsPreferencesMutationVariables,
        TContext
      > => {
      return useMutation(getPutNotificationsPreferencesMutationOptions(options), queryClient);
    }
